import { BackofficeTemplateDefault } from '../../Backoffice-Components/Backoffice-TemplateDefault/Backoffice-TemplateDefault';
import { BackofficeEditSpecialty } from '../../Backoffice-Components/Backoffice-EditSpecialty/Backoffice-EditSpecialty';

export const BackofficeEditSpecialtiesPage = () => {
  return (<>
    <BackofficeTemplateDefault body={<BackofficeEditSpecialty/>}/>
  </>);
};
